export default "__VITE_ASSET__nvoTLr$J__"